module.exports = __webpack_public_path__ + "static/media/patient-right.e163345b.jpg";